/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { MessageTemplateEntity } from '../types';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  readonly data?: MessageTemplateEntity[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: () => Promise<void>;
}

export default function useDataAPIGetMessageTemplatesByUserID(
  userID: string
): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getMessageTemplatesByUserID(userID);

      setState({ isLoading: false, data });
    } catch (error: any) {
      setState({ isLoading: false, error });
    }
  }

  useEffect(() => {
    fetch();
  }, []);

  return { ...state, refetch: fetch };
}
